// Phase 25 iter-15 (lote C) — admin KYC review client.
//
// Wraps the two endpoints that the SILLEDA_ADMIN web UI calls to clear the
// VET / TRANSPORTISTA review queue:
//   GET   /api/v1/admin/kyc/pending
//   PATCH /api/v1/admin/kyc/:assignmentId
//
// Both gated server-side by `isAdmin` (UserRole === 'SILLEDA_ADMIN'); the
// web caller is gated by /marketplace/admin/kyc-review route check.

import {
  API_VERSION_PREFIX,
  type AdminKycDecisionRequest,
  type AdminKycPendingResponse,
  type KycDocKind,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function listPendingKyc(): Promise<AdminKycPendingResponse> {
  const { data } = await apiClient.get<AdminKycPendingResponse>(
    `${API_VERSION_PREFIX}/admin/kyc/pending`,
  );
  return data;
}

export async function verdictKyc(
  assignmentId: string,
  decision: AdminKycDecisionRequest,
): Promise<void> {
  await apiClient.patch(`${API_VERSION_PREFIX}/admin/kyc/${assignmentId}`, decision);
}

export type { AdminKycDecisionRequest, AdminKycPendingResponse, KycDocKind };
